export default __webpack_public_path__ + "static/media/Note_Icon.7c5bf2a5.svg";